import React, { useEffect, useState } from 'react';
import { Layout, Button, Input, Alert, Card, Typography, Tag, Progress, Tabs, Spin, Table,message,Upload,Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import AppHeader from '../components/Header';
import { decryptData } from '../middleware/encryption';
import { InboxOutlined,ArrowLeftOutlined } from '@ant-design/icons';
import FileUpload from './file';
import './Bounce.css';

const { Content } = Layout;
const { Title, Text } = Typography;
const { Dragger } = Upload;

const { TabPane } = Tabs;
const API_ENDPOINT = 'https://api.app.exellius.com/api/bounce/check/';
const API_ENDPOINT_FILE = 'https://api.app.exellius.com/api/bounce/upload';

const role = sessionStorage.getItem('role');

const Bounce = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [email, setEmail] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);
  const [filesError, setFilesError] = useState(null);
 



  const [selectedFile, setSelectedFile] = useState(null);
    const [fileResponse, setFileResponse] = useState(null);
    const [fileLoading, setFileLoading] = useState(false);
    const [fileError, setFileError] = useState(null);
    
  const navigate = useNavigate();

  

  
  const FILE_LIST_API = `https://api.app.exellius.com/api/bounce/account/files`;

  const validateEmail = (value) => /\S+@\S+\.\S+/.test(value);

  const handleValidate = async () => {
    setError(null);
    setResponse(null);

    if (!email.trim()) {
      setError('Please enter an email address.');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email.');
      return;
    }

    setLoading(true);

    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      const token = sessionStorage.getItem('access_token');
      if (token) headers.append('Authorization', `Bearer ${token}`);

      const res = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers,
        body: JSON.stringify({ email }),
      });

      const result = await res.json();

      if (!res.ok) {
        setError(result?.message || 'Validation failed');
      } else {
        let parsed = result;
        if (result?.data) {
          parsed = decryptData(result.data) || result.data;
          console.log('Decrypted response:', parsed);
        }
        setResponse(parsed.data);
      }
    } catch (err) {
      setError(err?.message || 'Verification request failed');
    } finally {
      setLoading(false);
    }
  };

  const getStatusTag = () => {
    if (!response) return <Tag color="default">Unknown</Tag>;
    if (response.status === 'valid') return <Tag color="green">Valid</Tag>;
    if (response.status === 'invalid') return <Tag color="red">Invalid</Tag>;
    return <Tag color="orange">{response.status || 'Unknown'}</Tag>;
  };

  const booleanLabel = (value) => {
    if (value === null || value === undefined) return '--';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const loadFiles = async () => {
    setFilesError(null);
    setSelectedFile(null);
    setFiles([]);
    setFilesLoading(true);

    try {
      const token = sessionStorage.getItem('access_token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJhZG1pbkBnbWFpbC5jb20iLCJyb2xlSWQiOjEsImlhdCI6MTc3NjA4MDI5NSwiZXhwIjoxNzc2Njg1MDk1fQ.5ukAHzTvWk9gkmzHCTTjD1xb61cOj9UpUeoyAPOT5Qw';
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };

      const res = await fetch(FILE_LIST_API, requestOptions);
      const result = await res.json();

      if (!res.ok) {
        setFilesError(result?.message || 'Unable to load file list');
      } else {
        let fileData = result;

        if (result?.data) {
          const decoded = decryptData(result.data) || result.data;
          if (typeof decoded === 'string') {
            try {
              fileData = JSON.parse(decoded);
            } catch {
              fileData = decoded;
            }
          } else {
            fileData = decoded;
          }
        }

        setFiles(Array.isArray(fileData) ? fileData : fileData?.data || []);
      }
    } catch (err) {
      setFilesError(err?.message || 'Unable to load file list');
    } finally {
      setFilesLoading(false);
    }
  };

  useEffect(() => {
    loadFiles();
  }, []);

  const showFileResult = (file) => {
    setSelectedFile(file);
  };

  const handleViewResult = (fileId) => {
    navigate(`/verify/result/${fileId}`);
  };





    const handleFileUpload = async (file) => {
      setFileError(null);
      setFileResponse(null);
      setFileLoading(true);
  
      try {
        const token = sessionStorage.getItem('access_token');
        const myHeaders = new Headers();
        if (token) myHeaders.append('Authorization', `Bearer ${token}`);
  
        const formdata = new FormData();
        formdata.append('', file, file.name);
  
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow',
        };
  
        const res = await fetch(API_ENDPOINT_FILE, requestOptions);
        const result = await res.json();
  
        if (!res.ok) {
          const errorMessage =
  decryptData(result.data)?.error ||
  result?.message ||
  'File upload failed';
message.error(errorMessage);
        } else {
          let decryptedResult = result;
          if (result?.data) {
            decryptedResult = decryptData(result.data) || result.data;
          }
          console.log('File upload response:', decryptedResult);
          message.success(`${file.name} file uploaded successfully.`);
          
          // Redirect to job details page after successful upload
          if (decryptedResult?.job?.id) {
            setTimeout(() => {
              navigate(`/verify/result/${decryptedResult.job.id}`);
            }, 1500);
          }
        }
      } catch (err) {

        console.log('File upload error:', err);
        setFileError(err?.message || 'File upload failed');
        message.error('File upload failed.');
      } finally {
        setFileLoading(false);
      }
    };
  
    const handleSelectFile = (file) => {
      setSelectedFile(file);
      setFileError(null);
      return false; // Prevent default upload
    };
  
    const handleUploadClick = () => {
      if (selectedFile) {
        handleFileUpload(selectedFile);
      } else {
        message.warning('Please select a file first');
      }
    };
  
    const handleResetFile = () => {
      setSelectedFile(null);
      setFileError(null);
      setFileResponse(null);
    };
  
    const draggerProps = {
      name: 'file',
      multiple: false,
      accept: '.csv',
      beforeUpload: handleSelectFile,
      onDrop: (e) => {
        console.log('Dropped files', e.dataTransfer.files);
      },
    };

    const totalStats = files.reduce(
  (acc, file) => {
    acc.valid += Number(file.valid_count || 0);
    acc.invalid += Number(file.invalid_count || 0);
    acc.risky += Number(file.risky_count || 0);
    acc.unknown += Number(file.unknown_count || 0);

    return acc;
  },
  {
    valid: 0,
    invalid: 0,
    risky: 0,
    unknown: 0,
  }
);

  const tableColumns = [
    {
      title: 'File Name',
      dataIndex: 'file_name',
      key: 'file_name',
      render: (text) => <Text>{text || '--'}</Text>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        let color = 'default';
        if (text === 'completed') color = 'green';
        if (text === 'failed') color = 'red';
        if (text === 'pending') color = 'blue';
        return <Tag color={color}>{text || '--'}</Tag>;
      },
    },
    {
      title: 'Progress',
      dataIndex: 'progress',
      key: 'progress',
      render: (text) => <Text>{text ? `${text}%` : '--'}</Text>,
    },
    {
      title: 'Total Emails',
      dataIndex: 'total_emails',
      key: 'total_emails',
      render: (text) => <Text>{text ?? '--'}</Text>,
    },
    {
      title: 'Valid',
      dataIndex: 'valid_count',
      key: 'valid_count',
      render: (text) => <Text>{text ?? '--'}</Text>,
    },
    {
      title: 'Invalid',
      dataIndex: 'invalid_count',
      key: 'invalid_count',
      render: (text) => <Text>{text ?? '--'}</Text>,
    },
    {
      title: 'Risky',
      dataIndex: 'risky_count',
      key: 'risky_count',
      render: (text) => <Text>{text ?? '--'}</Text>,
    },
   {
  title: 'File Size',
  dataIndex: 'file_size',
  key: 'file_size',
  render: (text) => {
    if (!text) return <Text>--</Text>;
    
    const bytes = parseInt(text);
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    let i = 0;
    let size = bytes;
    
    while (size >= 1024 && i < sizes.length - 1) {
      size = size / 1024;
      i++;
    }
    
    return <Text>{size.toFixed(2)} {sizes[i]}</Text>;
  },
},
    {
      title: '',
      key: 'action',
      align:"right",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleViewResult(record.id)}>
          View Result
        </Button>
      ),
    },
  ];

  return (
  <Layout style={{ minHeight: '100vh', background: '#f5f7fb' }}>
    <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />

    <Layout>
      <AppHeader />

      <Content
        className="bounce-page"
        style={{
          padding: 24,
          height: '100vh',
          overflow: 'auto',
          background: '#f5f7fb',
        }}
      >
        <Card
          bordered={false}
          style={{
            borderRadius: 16,
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            marginBottom: 24,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 20,
              flexWrap: 'wrap',
            }}
          >
            <div>
              <Title level={2} style={{ marginBottom: 6 }}>
                Email Bounce Validation
              </Title>

              <Text type="secondary">
                Validate single emails or upload a CSV file for bulk bounce
                checking.
              </Text>
            </div>

            
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1.2fr 1fr',
              gap: 20,
              marginTop: 16,
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'center',
              }}
            >
              <Input
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onPressEnter={handleValidate}
                disabled={loading}
                style={{
                  height: 56,
                  borderRadius: 12,
                  fontSize: 15,
                }}
              />

              <Button
                type="primary"
                loading={loading}
                onClick={handleValidate}
                style={{
                  height: 56,
                  padding: '0 28px',
                  borderRadius: 12,
                  fontWeight: 600,
                  background:
                    'linear-gradient(135deg, #7c3aed 0%, #9333ea 100%)',
                  border: 'none',
                }}
              >
                Validate Email
              </Button>
            </div>

            <div
  style={{
    border: '1px dashed #d9d9d9',
    borderRadius: 14,
    padding: 20,
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 20,
    flexWrap: 'wrap',
  }}
>
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    }}
  >
    {/* CSV FILE IMAGE */}
    <div
      style={{
        width: 56,
        height: 56,
        borderRadius: 12,
        background: '#f8f8f8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <img
        src="/file.png"
        alt="CSV File"
        style={{
          width: 34,
          height: 34,
          objectFit: 'contain',
        }}
      />
    </div>

    <div>
      <Title level={5} style={{ marginBottom: 4 }}>
        Bulk Validation
      </Title>

      <Text type="secondary">
        Upload CSV file to validate multiple emails
       
      </Text>
      

      {selectedFile && (
        <div style={{ marginTop: 8 }}>
          <Tag color="purple">{selectedFile.name}</Tag>
        </div>
      )}
    </div>
    
  </div>

  <Upload
  accept=".csv"
  showUploadList={false}
  beforeUpload={(file) => {
    // FILE TYPE CHECK
    const isCsv =
      file.type === 'text/csv' ||
      file.name.toLowerCase().endsWith('.csv');

    if (!isCsv) {
      message.error('Only CSV files are allowed.');
      return Upload.LIST_IGNORE;
    }

    // READ CSV AND CHECK ROW LIMIT
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;

      // SPLIT ROWS
      const rows = text
        .split(/\r\n|\n/)
        .filter((row) => row.trim() !== '');

      // REMOVE HEADER ROW
      const totalRows = rows.length > 0 ? rows.length - 1 : 0;

      if ((totalRows > 10000) && role !== 'admin') {
        setFileError("The maximum upload limit is 10,000 records per file. For larger files, please contact us at contact@exellius.com");
        message.error(
          `The maximum upload limit is 10,000 records per file. For larger files, please contact us at contact@exellius.com`
        );
        return;
      }

      handleSelectFile(file);
      handleFileUpload(file);
    };

    reader.readAsText(file);

    return false;
  }}
>
  <Button
    type="primary"
    loading={fileLoading}
    style={{
      height: 44,
      padding: '0 22px',
      borderRadius: 10,
      background:
        'linear-gradient(135deg, #7c3aed 0%, #9333ea 100%)',
      border: 'none',
      fontWeight: 600,
    }}
  >
    {fileLoading ? 'Uploading...' : 'Upload CSV'}
  </Button>
</Upload>
</div>
 {fileError}
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginTop: 18 }}
            />
          )}
        </Card>

        {response && (
          <>
            {/* TOP SUMMARY */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1.2fr repeat(4, 1fr)',
                gap: 18,
                marginBottom: 22,
              }}
            >
              <Card
                bordered={false}
                style={{
                  borderRadius: 16,
                  background:
                    response.status === 'valid'
                      ? '#f6ffed'
                      : '#fff2f0',
                  border:
                    response.status === 'valid'
                      ? '1px solid #b7eb8f'
                      : '1px solid #ffccc7',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 18,
                  }}
                >
                 <div
  style={{
    width: 64,
    height: 64,
    borderRadius: '50%',
    background:
      response.status === 'valid'
        ? '#f6ffed'
        : '#fff2f0',
    border:
      response.status === 'valid'
        ? '2px solid #b7eb8f'
        : '2px solid #ffccc7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
  }}
>
  <img
    src={
      response.status === 'valid'
        ? '/success.png' // image in public folder
        : '/failed.png' // image in public folder
    }
    alt={response.status}
    style={{
      width: 34,
      height: 34,
      objectFit: 'contain',
    }}
  />
</div>

                  <div>
                    <Text type="secondary">Validation Result</Text>

                    <Title
                      level={2}
                      style={{
                        margin: '6px 0 4px',
                        color:
                          response.status === 'valid'
                            ? '#389e0d'
                            : '#cf1322',
                      }}
                    >
                      {response.final_status || response.status || '--'}
                    </Title>

                    <Text type="secondary">
                      {response.final_status != 'valid'
                        ? response.status_reason : ''}
                    </Text>
                  </div>
                </div>
              </Card>

              <Card bordered={false} style={{ borderRadius: 16 }}>
                <Title
                  level={2}
                  style={{
                    marginBottom: 4,
                    color: '#16a34a',
                  }}
                >
                  {response.quality_check?.email_quality_score || '0%'}
                </Title>

                <Text type="secondary">Email Quality Score</Text>

                <Progress
                  percent={Number(
                    response.quality_check?.email_quality_score?.replace(
                      '%',
                      ''
                    ) || 0
                  )}
                  showInfo={false}
                  strokeColor="#52c41a"
                />
              </Card>

              <Card bordered={false} style={{ borderRadius: 16 }}>
                <Title level={3} style={{ marginBottom: 4 }}>
                  {response.quality_check?.can_receive_email || 'Unknown'}
                </Title>

                <Text type="secondary">Can receive email</Text>
              </Card>

              <Card bordered={false} style={{ borderRadius: 16 }}>
                <Title level={3} style={{ marginBottom: 4 }}>
                  {response.disposable ? 'Yes' : 'No'}
                </Title>

                <Text type="secondary">Disposable</Text>
              </Card>

              <Card bordered={false} style={{ borderRadius: 16 }}>
                <Title
                  level={3}
                  style={{
                    marginBottom: 4,
                    color: '#16a34a',
                  }}
                >
                  {response.quality_check?.valid_domain || 'Yes'}
                </Title>

                <Text type="secondary">Valid Domain</Text>
              </Card>
            </div>

            {/* DETAILS GRID */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 20,
                marginBottom: 24,
              }}
            >
              {/* EMAIL DETAILS */}
              <Card
                title="Email Details"
                bordered={false}
                style={{ borderRadius: 16 }}
              >
                <div className="detail-row">
                  <Text type="secondary">Email</Text>
                  <Text strong>{response.email || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Domain</Text>
                  <Text>{response.attributes?.domain || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Provider</Text>
                  <Text>{response.attributes?.provider || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Username</Text>
                  <Text>{response.attributes?.username || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Accept All</Text>
                  <Text>{booleanLabel(response.accept_all)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Disposable</Text>
                  <Text>{booleanLabel(response.disposable)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Role Account</Text>
                  <Text>{booleanLabel(response.role_account)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Free Email</Text>
                  <Text>{booleanLabel(response.free_email)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Webmail</Text>
                  <Text>{booleanLabel(response.webmail)}</Text>
                </div>
              </Card>

              {/* SMTP */}
              <Card
                title="SMTP & Connection"
                bordered={false}
                style={{ borderRadius: 16 }}
              >
                <div className="detail-row">
                  <Text type="secondary">SMTP Check</Text>
                  <Text>{booleanLabel(response.smtp_check)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Blocked</Text>
                  <Text>{booleanLabel(response.is_blocked)}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Connection Failure</Text>
                  <Text>
                    {booleanLabel(response.is_connection_failure)}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">SMTP Server</Text>
                  <Text>{response.smtp_server || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">SMTP Response</Text>
                  <Text>{response.smtp_response || '--'}</Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Validation Method</Text>
                  <Text>{response.validation_method || '--'}</Text>
                </div>
              </Card>

              {/* QUALITY */}
              <Card
                title="Quality Breakdown"
                bordered={false}
                style={{ borderRadius: 16 }}
              >
                <div className="detail-row">
                  <Text type="secondary">Can receive email</Text>
                  <Text>
                    {response.quality_check?.can_receive_email || '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Disposable address</Text>
                  <Text>
                    {response.quality_check?.disposable_address || '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Email quality score</Text>
                  <Text>
                    {response.quality_check?.email_quality_score || '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Not a catchall</Text>
                  <Text>
                    {response.quality_check?.not_a_catchall_address ||
                      '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Not generic</Text>
                  <Text>
                    {response.quality_check?.not_a_generic_address ||
                      '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Valid domain</Text>
                  <Text>
                    {response.quality_check?.valid_domain || '--'}
                  </Text>
                </div>

                <div className="detail-row">
                  <Text type="secondary">Valid format</Text>
                  <Text>
                    {response.quality_check?.valid_format || '--'}
                  </Text>
                </div>

                <div style={{ marginTop: 20 }}>
                  <Text strong>Email Quality Score</Text>

                  <Progress
                    percent={Number(
                      response.quality_check?.email_quality_score?.replace(
                        '%',
                        ''
                      ) || 0
                    )}
                    strokeColor={{
                      '0%': '#ff4d4f',
                      '50%': '#faad14',
                      '100%': '#52c41a',
                    }}
                  />
                </div>
              </Card>
            </div>

            {/* MX RECORDS */}
            <Card
              title="MX Records"
              bordered={false}
              style={{
                borderRadius: 16,
                marginBottom: 28,
              }}
            >
              {Array.isArray(response.mx_records) &&
              response.mx_records.length > 0 ? (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  {response.mx_records.map((record) => (
                    <Tag
                      key={record}
                      color="blue"
                      style={{
                        padding: '6px 12px',
                        borderRadius: 8,
                      }}
                    >
                      {record}
                    </Tag>
                  ))}
                </div>
              ) : (
                <Text type="secondary">
                  No MX records available.
                </Text>
              )}
            </Card>
          </>
        )}

        {/* FILE SECTION */}
        <Card
          bordered={false}
          style={{
            borderRadius: 16,
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 24,
            }}
          >
            <Title level={3} style={{ margin: 0 }}>
              File Verification
            </Title>

            
          </div>

         <div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
    gap: 18,
    marginBottom: 28,
  }}
>
  {/* VALID */}
  <Card
    bordered={false}
    style={{
      borderRadius: 16,
      border: '1px solid #b7eb8f',
      background: '#f6ffed',
      overflow: 'hidden',
    }}
    bodyStyle={{
      padding: 22,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <Text
          style={{
            color: '#389e0d',
            fontWeight: 500,
          }}
        >
          Valid Emails
        </Text>

        <Title
          level={2}
          style={{
            margin: '10px 0 0',
            color: '#52c41a',
            fontWeight: 700,
          }}
        >
          {totalStats.valid}
        </Title>
      </div>

      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#52c41a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        ✓
      </div>
    </div>
  </Card>

  {/* INVALID */}
  <Card
    bordered={false}
    style={{
      borderRadius: 16,
      border: '1px solid #ffccc7',
      background: '#fff2f0',
      overflow: 'hidden',
    }}
    bodyStyle={{
      padding: 22,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <Text
          style={{
            color: '#cf1322',
            fontWeight: 500,
          }}
        >
          Invalid Emails
        </Text>

        <Title
          level={2}
          style={{
            margin: '10px 0 0',
            color: '#ff4d4f',
            fontWeight: 700,
          }}
        >
          {totalStats.invalid}
        </Title>
      </div>

      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#ff4d4f',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        ✕
      </div>
    </div>
  </Card>

  {/* RISKY */}
  <Card
    bordered={false}
    style={{
      borderRadius: 16,
      border: '1px solid #ffe58f',
      background: '#fffbe6',
      overflow: 'hidden',
    }}
    bodyStyle={{
      padding: 22,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <Text
          style={{
            color: '#d48806',
            fontWeight: 500,
          }}
        >
          Risky Emails
        </Text>

        <Title
          level={2}
          style={{
            margin: '10px 0 0',
            color: '#faad14',
            fontWeight: 700,
          }}
        >
          {totalStats.risky}
        </Title>
      </div>

      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#faad14',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        !
      </div>
    </div>
  </Card>

  {/* UNKNOWN */}
  <Card
    bordered={false}
    style={{
      borderRadius: 16,
      border: '1px solid #adc6ff',
      background: '#f0f5ff',
      overflow: 'hidden',
    }}
    bodyStyle={{
      padding: 22,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <Text
          style={{
            color: '#1d39c4',
            fontWeight: 500,
          }}
        >
          Unknown Emails
        </Text>

        <Title
          level={2}
          style={{
            margin: '10px 0 0',
            color: '#1677ff',
            fontWeight: 700,
          }}
        >
          {totalStats.unknown}
        </Title>
      </div>

      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#1677ff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        ?
      </div>
    </div>
  </Card>
</div>

          {/* TABLE */}
          {filesLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: 20,
              }}
            >
              <Spin />
              <Text style={{ marginLeft: 12 }}>
                Loading file verification results...
              </Text>
            </div>
          ) : filesError ? (
            <Alert
              message={filesError}
              type="error"
              showIcon
            />
          ) : files.length === 0 ? (
            <Text type="secondary">
              No file verification results found yet.
            </Text>
          ) : (
            <Table
              columns={tableColumns}
              dataSource={files}
              rowKey="id"
              pagination={{ pageSize: 10 }}
              size="middle"
              style={{ marginBottom: 28 }}
            />
          )}

       

         

         
        </Card>
      </Content>
    </Layout>
  </Layout>
);
};

export default Bounce;
